const publicUrl = process.env.PUBLIC_URL + "/img"

export const pictures = {
    background: `${publicUrl}/background.png`,
    backRegister: `${publicUrl}/backRegister.svg`,
}
